import request from '@/sheep/request';

// 分类
export interface Category {
	id : string
	name : string
	icon : string
	picUrl ?: string
	wishTotal ?: string
	description ?: string
}


// 查询分类精简列表
export const getCategorySimpleList = () => {
	return request({
		url: '/wish/category/list-simple',
		method: 'GET',
	});
}

// 查询分类列表
export const getCategoryList = () => {
	return request({
		url: '/wish/category/list',
		method: 'GET',
	});
}
